<nav
  id="sidebar"
  class="navbar navbar-expand-xl d-flex align-items-start pt-0 pb-0 h-100"
>
  <div class="nav-container h-100">
    <button
      class="navbar-toggler position-absolute border-0"
      (click)="toggleSideNav()"
      [attr.aria-label]="hideSideNav ? 'Close navigation panel' : 'Open navigation panel'"
      [attr.aria-expanded]="hideSideNav"
      aria-controls="sidebar"
    >
      <span
        *ngIf="hideSideNav"
        class="bi bi-x-lg position-relative navbar-toggler-close"
      ></span>
      <span
        *ngIf="!hideSideNav"
        class="navbar-toggler-icon position-relative"
      ></span>
    </button>
    <div
      class="collapse navbar-collapse nav-icons flex-column pt-4"
      [ngClass]="{ show: hideSideNav }"
    >
      <ul class="navbar-nav flex-column mt-2" role="menu">
        <li
          *ngFor="let navList of navigationList; let i = index"
          class="nav-list nav-item"
          id="side-nav-list" role="none"
        >
          <ng-container>
            <button
              class="icon-{{ navList.iconName }} icons-button"
              name="{{ navList.name }}"
              [attr.aria-label]="navList.name"
              role="menuitem"
              [attr.aria-haspopup]="navList.subMenuItems.length > 0"
              [attr.aria-expanded]="navList.subMenuItems.length > 0 ? subNavShowIndex === i + 1 : null"
              [attr.aria-controls]="navList.subMenuItems.length > 0 ? 'subnav-' + navList.iconName : null"
              [attr.aria-posinset]="i + 1"
              [attr.aria-setsize]="navigationList.length"
              (touchstart)="handleNavInteraction(navList, i)"
              (click)="handleNavInteraction(navList, i)"
              [ngClass]="{
                disabled: isFirstLogin,
                'selected-icon': selectedMainNav?.name === navList.name || subNavShowIndex === i + 1,
              }"
              [disabled]="isFirstLogin"
              [attr.aria-disabled]="isFirstLogin"
              [style.pointer-events]="isFirstLogin ? 'none' : 'auto'"
            >
              <div
                role="img"
                aria-label="nav-icon"
              >
                <svg class="icon-size-20">
                  <use
                    [attr.xlink:href]="
                      '../../../assets/icons/svg-sprite.svg#icon-' + navList.iconName
                    "
                  />
                </svg>
              </div>
            </button>
            <div
              class="sub-nav-list"
              role="menu"
              [id]="'subnav-' + navList.iconName"
              *ngIf="navList.subMenuItems.length > 0"
              [ngClass]="{ hide: subNavShowIndex !== i + 1, visible: subNavShowIndex === i + 1 }"
            >
              <p *ngFor="let subNavName of navList.subMenuItems; let j = index">
                <button
                  tabindex="0"
                  role="link"
                  class="w-100 text-nowrap"
                  [ngClass]="{ 'disabled-admin-state': isDisabled(subNavName).visuallyDisabled }"
                  [attr.aria-disabled]="isDisabled(subNavName).visuallyDisabled"
                  [attr.aria-label]="subNavName.name + ' ' + (j + 1) + ' of ' + navList.subMenuItems.length"
                  [attr.aria-posinset]="j + 1"
                  [attr.aria-setsize]="navList.subMenuItems.length"
                  [pTooltip]="isDisabled(subNavName).tooltip"
                  [style.cursor]="isDisabled(subNavName).cursor"
                  (click)="
                    isDisabled(subNavName).canNavigate && navigateTo(subNavName);
                    subNavShowIndex = 0
                  "
                >
                  {{ subNavName.name }}
                </button>
              </p>
            </div>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
</nav>
